import { render, staticRenderFns } from "./reservation-messages.vue?vue&type=template&id=2422bbb6&"
import script from "./reservation-messages.vue?vue&type=script&lang=ts&"
export * from "./reservation-messages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports